import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { tenantService } from "../../Services/tenant.service";
import { globalServices } from "../../Services/global.service";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import Select from "react-select";
import { validationService } from "../../Services/validation.service";
import {
  numbersOnly,
  ibanNum,
  lettersOnly,
  address,
  OIB,
} from "../../Config/Regex";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";

const TenantUpdate = (props) => {
  const { t: translator } = useTranslation();
  const history = useHistory();
  let id = props.match.params.tenantId;
  const { locTenant, locName } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support, owner } = roles;
  const [countries, setCountries] = useState([]);
  const [postOffices, setPostOffices] = useState([]);
  const [backUrl, setBackUrl] = useState();
  const [city, setCity] = useState();
  const [tenant, setTenant] = useState({
    tenantId: id,
    name: "",
    code: "",
    owner: "",
    taxNumber: "",
    street: "",
    streetNumber: null,
    streetNumberExtension: "",
    city: "",
    countryId: "",
    postalNumber: "",
    iban: null,
    fiscalObligation: true,
    taxObligation: null,
    taxNote: "",
  });

  const { register, handleSubmit, errors, control, formState, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
      defaultValues: { tenant },
    });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const goBack = () => {
    history.push(backUrl);
  };

  const handleCancel = () => {
    goBack();
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  useEffect(() => {
    setBackUrl(`/${locName}/${locTenant != 0 ? locTenant : ""}`);
    if (![master, admin, support, owner].includes(Number(roleId)))
      history.push("/error-page/401");
    else {
      tenantService
        .getById(id)
        .then((res) => {

          console.log("SS",res.data);
          setTenant(res.data);
          setCity(res.data.city);
        })
        .catch((err) => console.log(err));

      globalServices
        .getCountries()
        .then((res) => setCountries(res.data))
        .catch((err) => console.log(err));

      globalServices
        .getPostOffices()
        .then((data) => {
          setPostOffices(data.data);
        })
        .catch(() => history.push("/Error"));
    }
  }, []);

  const getCity = (id, postal) => {
    globalServices
      .getCityByPostOffice(id)
      .then((res) => {
        setValue("city", res.data.data.name, { shouldValidate: true });
        setCity(res.data.data.name);
      })
      .catch(() => history.push("/Error"));
  };

  async function codeValidation(code) {
    if (code != tenant.code) {
      return await validationService.validateCode(code);
    } else {
      return true;
    }
  }

  const onSubmit = (data) => {
    tenantService
      .update({
        tenantId: id,
        name: data.name,
        code: data.code,
        owner: data.owner,
        taxNumber: data.taxNumber,
        street: data.street,
        streetNumber: Number(data.streetNumber),
        streetNumberExtension: data.streetNumberExtension,
        city: data.city,
        countryId: Number(data.countryId),
        postalNumber: data.postalNumber.value,
        iban: data.iban != ""  ? "HR" + data.iban : "",
        fiscalObligation: data.fiscalObligation,
        taxObligation: Number(data.taxObligation),
        taxNote: data.taxNote,
        useAccounting: Boolean(data.useAccounting),
        //useAccounting: false,
      })
      .then((res) => {
        res.data.success
          ? setModal({
            show: true,
            title: translator("Tenant-Update-ModalSuccessTitle"),
            text: translator("Tenant-Update-ModalSuccessText"),
            btnClass: "btn btn-primary",
            success: true,
          })
          : setModal({
            show: true,
            title: translator("Tenant-Update-ModalUnsuccessTitle"),
            text: translator("Tenant-Update-ModalUnsuccessText"),
            btnClass: "btn btn-primary",
            success: false,
          });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("Tenant-Update-ModalUnsuccessTitle"),
          text: translator("Tenant-Update-ModalUnsuccessText"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  return (
    <CardWrap
      entity={tenant.name}
      subtitle={translator("Tenant-Update-Subtitle-UpdateTenant")}
      backUrl={backUrl}
    >
      {tenant.name !== "" && (
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("Tenant-Update-MainData")}
              </legend>
              <div className="form-group">
                <label htmlFor="taxNumber">
                  {translator("Tenant-Update-TaxNumber")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  disabled={![master, admin, support].includes(Number(roleId)) ? true : false}
                  name="taxNumber"
                  ref={register({
                    required: true,
                    pattern: OIB,
                    validate: () =>
                      document.getElementsByName("taxNumber")[0].value !==
                        tenant.taxNumber
                        ? validationService.validateTenantOib(
                          document.getElementsByName("taxNumber")[0].value
                        )
                        : true,
                  })}
                  defaultValue={tenant.taxNumber}
                />
                {errors.taxNumber && errors.taxNumber.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.taxNumber && errors.taxNumber.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-OIBNotValid")}
                  </p>
                )}
                {errors.taxNumber && errors.taxNumber.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-OIBLength")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="name">{translator("Tenant-Update-Name")}</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  ref={register({ required: true, maxLength: 250 })}
                  defaultValue={tenant.name}
                />
                {errors.name && errors.name.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.name && errors.name.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength250")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="code">
                  {translator("Tenant-Update-Password")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  ref={register({
                    required: true,
                    maxLength: 20,
                    validate: () =>
                      codeValidation(
                        document.getElementsByName("code")[0].value
                      ),
                  })}
                  defaultValue={tenant.code}
                />
                {errors.code && errors.code.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.code && errors.code.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-Tenant-Code")}
                  </p>
                )}
                {errors.code && errors.code.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength20")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="owner">
                  {translator("Tenant-Update-Owner")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="owner"
                  ref={register({
                    required: true,
                    maxLength: 50,
                    pattern: lettersOnly,
                  })}
                  defaultValue={tenant.owner}
                />
                {errors.owner && errors.owner.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.owner && errors.owner.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength50")}
                  </p>
                )}
                {errors.owner && errors.owner.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersOnly")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="iban">IBAN</label>
                <div class="input-group mb-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                    >
                      HR
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name="iban"
                    ref={register({
                      //required: true,
                      pattern: ibanNum,
                    })}
                    defaultValue={
                      tenant.iban == null ? "" : tenant.iban.substring(2)
                    }
                  />
                </div>
                {/* {errors.iban && errors.iban.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )} */}
                {errors.iban && errors.iban.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-IBAN")}
                  </p>
                )}
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("Tenant-Update-AdressInformation")}
              </legend>
              <div className="form-group">
                <label htmlFor="street">
                  {translator("Tenant-Update-Street")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="street"
                  ref={register({
                    required: true,
                    pattern: address,
                    maxLength: 150,
                  })}
                  defaultValue={tenant.street}
                />
                {errors.street && errors.street.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.street && errors.street.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength150")}
                  </p>
                )}
                {errors.street && errors.street.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersOnly")}
                  </p>
                )}
              </div>
              <div className="form-row">
                <div className="form-group col-md-8">
                  <label htmlFor="streetNumber">
                    {translator("Tenant-Update-StreetNumber")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumber"
                    ref={register({
                      required: true,
                      pattern: numbersOnly,
                      maxLength: 6,
                    })}
                    defaultValue={tenant.streetNumber}
                  />
                  {errors.streetNumber &&
                    errors.streetNumber.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength6")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumberOnly")}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label htmlFor="streetNumberExtension">
                    {translator("Tenant-Update-StreetNumberAddition")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumberExtension"
                    ref={register({ maxLength: 10 })}
                    defaultValue={tenant.streetNumberExtension}
                  />
                  {errors.streetNumberExtension &&
                    errors.streetNumberExtension.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength10")}
                      </p>
                    )}
                  {errors.streetNumberExtension &&
                    errors.streetNumberExtension.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-LettersOnly")}
                      </p>
                    )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-5">
                  <label htmlFor="postalNumber">
                    {translator("Tenant-Update-ZipCode")}
                  </label>

                  {postOffices.length != 0 && (
                    <Controller
                      as={Select}
                      ref={register({
                        required: true,
                      })}
                      options={
                        postOffices &&
                        postOffices.map((p) => ({
                          id: p.id,
                          label: p.name,
                          value: p.name,
                        }))
                      }
                      name="postalNumber"
                      defaultValue={{
                        label:
                          postOffices.length != 0 ? tenant.postalNumber : "",
                        value:
                          postOffices.length != 0 ? tenant.postalNumber : "",
                      }}
                      control={control}
                      onChange={function (event) {
                        getCity(event[0].id, event[0].label);
                        return event[0];
                      }}
                    />
                  )}
                  {errors.postalNumber &&
                    errors.postalNumber.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-7">
                  <label htmlFor="city">
                    {translator("Tenant-Update-City")}
                  </label>
                  <input

                    type="text"
                    className="form-control"
                    ref={register()}
                    name="city"
                    defaultValue={tenant.city}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="countryId">
                  {translator("Tenant-Update-State")}
                </label>
                {countries.length > 0 && (
                  <select
                    className="form-control"
                    name="countryId"
                    ref={register({ required: true })}
                    defaultValue={Number(tenant.countryId)}
                  >
                    {countries.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                )}
                {errors.countryId && errors.countryId.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("Tenant-Update-MoreInformation")}
              </legend>
              <div className="form-group">
                <label>{translator("Tenant-Update-TaxLiability")}?</label>
                <select
                  defaultValue={Number(tenant.taxObligation)}
                  className="form-control"
                  name="taxObligation"
                  ref={register({ required: true })}
                >
                  <option value={1}>
                    {translator("Tenant-Update-TaxLiabilitySelect-Yes")}
                  </option>
                  <option value={0}>
                    {translator("Tenant-Update-TaxLiabilitySelect-No")}
                  </option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="iban">
                  {translator("Tenant-Update-TaxNote")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="taxNote"
                  ref={register({ maxLength: 250 })}
                  defaultValue={tenant.taxNote}
                />
                {errors.taxNote && errors.taxNote.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength250")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {tenant.name !== "" && (
                    <input
                      type="checkbox"
                      name="fiscalObligation"
                      defaultChecked={tenant.fiscalObligation}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span>{translator("Tenant-Update-FiscalObligation")}?</span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="useAccounting"
                    ref={register}
                    defaultChecked={tenant.useAccounting}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("Onboarding-TenantData-IsAccounting")}</span>{" "}
              </div>
            </fieldset>
          </div>
          <div
            className="container-fluid"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("Tenant-Update-BtnCancel")}
            </button>
            &nbsp;
            <button
              disabled={!formState.dirty}
              className="btn btn-primary"
              type="submit"
            >
              {translator("Tenant-Update-BtnSave")}
            </button>
          </div>
        </form>
      )}
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
};

export default TenantUpdate;
